export default function track(pageCode, appId, flowCode = 'iamlogin', errorCode){
    trackWa({ flowCode, pageCode, errorCode, appId });
};

/**
 * Created by jbeach on 2024-09-04
 * Updated by jbeach on 2024-09-04
 *  ----
 * DDL Schema for IAM Applications
 * https://confluence.collegeboard.org/display/wa/IAM+Okta+2023+WA
 * IAM - paLoginCloud - Server Rendered (FreeMarker) Pages IAM
 */

// Common Track Function
const trackWa = function ({
                              flowCode = '',
                              pageCode = '',
                              errorCode = '',
                              appId = '',
                          }) {
    if (pageCode && pageCode === '500errorpage'){
        errorCode = '500';
    }

    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
        event: 'cbTrackEvent',
        eventInfo: {
            eventKey: 'pageView',
            eventData: {
                page: {
                    flowCode,
                    pageCode,
                    errorCode,
                },
                iam: {
                    appId,
                },
            },
        },
    });
    try {
        _satellite.track('cbTrack.viewInDom');
    } catch (errSatelliteTrack) {}
};


export function setPageTitle(pageTitle) {
    document.title = pageTitle + ' - College Board';
}

export function setPageDescription(description) {
    let node = document.createElement('meta');
    node.setAttribute('name', 'description');
    node.setAttribute('content', description);

    document.head.appendChild(node);
}